<template>
    <grid-container class="admin-footer">
        <grid-column>
            <strong>We provide help at</strong><br />
            <a href="mailto:support@columns.co.uk">support@columns.co.uk</a>
        </grid-column>
        <grid-column>
            <strong>Give us a call</strong><br />
            (0)20 7395 6500
        </grid-column>
        <grid-column>
            <strong>Website</strong><br/>
            <a
                href="https://www.columns.co.uk/"
                target="_blank"
            >
                www.columns.co.uk
            </a>
        </grid-column>
    </grid-container>
</template>

<style>
.admin-footer {
    @apply w-full mt-8;

    .grid-column {
        @apply col-span-12 md:col-span-6 xl:col-span-3 text-base text-dusty-gray mb-4 xl:mb-0;
    }

    a:hover {
        @apply text-grey-1;
    }
}
</style>
